import styles from './orders-page.module.scss';
import { Tabs } from "antd";
import { useEffect } from "react";
import ordersStorage from "../../storages/orders.storage";
import { observer } from "mobx-react-lite";
import layoutStorage from "../../storages/layout-storage";
import { AddOrderDialog } from "../../dialogs/add-order-dialog";
import partTypesStorage from "../../storages/part-types";
import Items from "./containers/items";
import Orders from "./containers/orders";
import Tracking from "./containers/tracking";
import Recipients from "./containers/recipients";

export function OrdersPage() {
  useEffect(() => {
    ordersStorage.loadOrders();
    partTypesStorage.loadPartTypes();
  }, []);

  return (
    <div className={styles['container']}>
      <Tabs
        defaultActiveKey="orders"
      >
        <Tabs.TabPane tab="Orders" key="orders" >
          <Orders
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Items" key="items" >
          <Items
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Tracking" key="tracking" >
          <Tracking
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Recipients" key="recipients" >
          <Recipients
          />
        </Tabs.TabPane>
      </Tabs>
      {layoutStorage.dialogs.addOrderDialog.opened && (
        <AddOrderDialog opened={layoutStorage.dialogs.addOrderDialog.opened} />
      )}
    </div>
  );
}

export default observer(OrdersPage);
